const ANDROID_REGEX = /Android/i;
const ANDROID_NON_CHROME_REGEX = /(Firefox|FxiOS|EdgA|OPR|SamsungBrowser|DuckDuckGo|; wv\)|Version\/\d+\.\d+ Chrome)/i;
const CHROME_REGEX = /Chrome\/\d+/i;
const IOS_REGEX = /iPhone|iPad|iPod/i;
const MOBILE_REGEX = /Mobile/i;
const WEBVIEW_REGEX = /(WebView|; wv\)|Phantom|Solflare|Backpack|Trust|CoinbaseWallet|MetaMask)/i;
const MOBILE_WALLET_BROWSER_MESSAGE =
  "On mobile, use your wallet's in-app browser, such as Phantom or Solflare, instead of Chrome or Safari to connect and sign.";

export function isIosBrowser(userAgent = "") {
  return IOS_REGEX.test(userAgent);
}

export function isAndroidMobileBrowser(userAgent = "") {
  return ANDROID_REGEX.test(userAgent) && MOBILE_REGEX.test(userAgent);
}

export function isAndroidChromeMobileBrowser(userAgent = "") {
  return isAndroidMobileBrowser(userAgent) && CHROME_REGEX.test(userAgent) && !ANDROID_NON_CHROME_REGEX.test(userAgent);
}

export function isMobileBrowser(userAgent = "") {
  return isAndroidMobileBrowser(userAgent) || isIosBrowser(userAgent);
}

export function isWalletInAppBrowser(userAgent = "") {
  return WEBVIEW_REGEX.test(userAgent);
}

export function isMobileWalletAdapterConnector(connector) {
  const id = String(connector?.id || "").toLowerCase();
  const name = String(connector?.name || "").toLowerCase();
  return name === "mobile wallet adapter" || id.includes("mobile-wallet-adapter") || id.startsWith("mwa:");
}

export function getWalletEnvironment(userAgent = "") {
  if (isWalletInAppBrowser(userAgent)) {
    return "wallet-browser";
  }

  if (isMobileBrowser(userAgent)) {
    return "mobile-browser";
  }

  return "desktop-browser";
}

export function getAndroidWalletBrowserMessage(userAgent = "") {
  return isAndroidMobileBrowser(userAgent) && !isWalletInAppBrowser(userAgent) ? MOBILE_WALLET_BROWSER_MESSAGE : "";
}

export function getMobileWalletBrowserMessage({ connectors = [], userAgent = "" } = {}) {
  if (!isMobileBrowser(userAgent) || isWalletInAppBrowser(userAgent)) {
    return "";
  }

  if (connectors.length > 0 && !connectors.some(isDetectedWalletConnector)) {
    return "";
  }

  return MOBILE_WALLET_BROWSER_MESSAGE;
}

export function getWalletSupportMessage({ connectors = [], userAgent = "" } = {}) {
  const mobileWalletBrowserMessage = getMobileWalletBrowserMessage({ connectors, userAgent });
  if (mobileWalletBrowserMessage) {
    return mobileWalletBrowserMessage;
  }

  const environment = getWalletEnvironment(userAgent);

  if (connectors.length > 0) {
    return "";
  }

  if (environment === "wallet-browser") {
    return "No compatible wallet connector was detected in this wallet browser.";
  }

  return "Install a Wallet Standard-compatible wallet extension.";
}

export function isUsableConnector(connector) {
  return Boolean(connector?.id && connector?.name && typeof connector?.isSupported === "function" && connector.isSupported());
}

function isDetectedWalletConnector(connector) {
  if (!connector) return false;
  const id = String(connector.id || "").toLowerCase();
  const kind = String(connector.kind || "").toLowerCase();
  const provider = String(connector.provider || "").toLowerCase();
  return (
    provider !== "privy" &&
    kind !== "embedded-wallet" &&
    kind !== "phantom-embedded" &&
    !id.startsWith("privy-embedded") &&
    !id.startsWith("phantom-embedded")
  );
}
